if (!customElements.get('media-gallery')) {
  customElements.define('media-gallery', class MediaGallery extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        viewer: this.querySelector('[id^="GalleryViewer"]'),
        thumbnails: this.querySelector('[id^="GalleryThumbnails"]'),
        prevButton: this.querySelector('button[name="previous"]'),
        nextButton: this.querySelector('button[name="next"]'),
        activeMedia: this.querySelector('.is-active'),
        list: this.querySelector('.media-gallery__list'),
        progressBar: this.querySelector('[data-gallery-progress-bar]'),
       videoLink: this.querySelector('#video-link'),
        imageLink: this.querySelector('#image-link')
      }

      // Show Variant Image on page load if the URL has a variant query param
      const queryString = window.location.search;
      const urlParams = new URLSearchParams(queryString);

      if (!urlParams.has('variant')) {
        this.loadGallery();
      } else {
        const variantId = urlParams.get('variant');
        const productTemplateVariantSelects = document.getElementById('ProductHero').querySelector('variant-selects');

        if (productTemplateVariantSelects) {
          productTemplateVariantSelects.updateMasterIdWithVariantId(variantId);
        }

        setTimeout(() => {
          this.loadGallery();
        }, "1000");
      }

      if (this.elements.thumbnails) {
        let videoLinkEle = '';
        let imageLinkEle = '';
        let count = 1;
        this.elements.thumbnails.querySelectorAll('[data-target]').forEach((mediaToSwitch,index) => {
          const mediaId = mediaToSwitch.dataset.target;
          mediaToSwitch.querySelector('button').addEventListener('click', this.setActiveMedia.bind(this, mediaToSwitch.dataset.target, false));
          // Assign 4th & 5th items (adjust if needed)
            if (count === 4) videoLinkEle = mediaId;
            if (count === 5) imageLinkEle = mediaId;

          count++;
          });
          
         if (this.elements.videoLink && videoLinkEle) {
          this.elements.videoLink.addEventListener('click', this.setActiveMedia.bind(this, videoLinkEle, false));
        }

        // Image link click
        if (this.elements.imageLink && imageLinkEle) {
          this.elements.imageLink.addEventListener('click', this.setActiveMedia.bind(this, imageLinkEle, false));
        }

      }

      
      if (this.elements.nextButton) {
        this.setArrowButtons(this.elements.activeMedia);

        this.elements.prevButton.addEventListener('click', this.onArrowButtonClick.bind(this));
        this.elements.nextButton.addEventListener('click', this.onArrowButtonClick.bind(this));
      }

      this.initDragToScroll();
      this.initScrollProgress();
    }

    loadGallery() {
      this.classList.add('is-loaded');
    }

    updateThumbnail(mediaId) {
      if (this.elements.thumbnails) {
        const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${ this.dataset.galleryId}-${ mediaId }"]`);
        this.setActiveThumbnail(activeThumbnail);
      }
    }

    setActiveMedia(mediaId) {
      window.pauseAllMedia();
      this.preventPageShift();

      const activeMedia = this.querySelector(`[data-slide-media-id="${mediaId}"]`);

      this.elements.viewer.querySelectorAll('[data-slide-media-id]').forEach((element) => {
        const imageContainer = element.querySelector('.js-media-gallery-image-container');
        element.classList.remove('is-active');
        if (imageContainer) {
          imageContainer.classList.remove('loaded');
        }
      });
      
      const activeMediaImageContainer = activeMedia.querySelector('.js-media-gallery-image-container');
      activeMedia.classList.add('is-active');
      if (activeMediaImageContainer) {
        activeMediaImageContainer.classList.add('loaded');
      }

      this.preventStickyHeader();
      window.setTimeout(() => {
        if (this.elements.thumbnails) {
          activeMedia.parentElement.scrollTo({ left: activeMedia.offsetLeft });
        } 

        if (this.elements.nextButton) {
          activeMedia.scrollIntoView({behavior: 'smooth'});
        }
      });

      this.playActiveMedia(activeMedia);

      if (this.elements.thumbnails) {
        const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${ mediaId }"]`);
        this.setActiveThumbnail(activeThumbnail);
      }

      this.setArrowButtons(activeMedia);

    }

    setArrowButtons(activeMedia) {
      if (!this.elements.prevButton) return; 
      if (activeMedia.previousElementSibling == null) {
        this.elements.prevButton.setAttribute('disabled', true);
      } else {
        this.elements.prevButton.removeAttribute('disabled');
      }

      if (activeMedia.nextElementSibling == null) {
        this.elements.nextButton.setAttribute('disabled', true);
      } else {
        this.elements.nextButton.removeAttribute('disabled');
      }
    }

    setActiveThumbnail(thumbnail) {
      if (!this.elements.thumbnails || !thumbnail) return;
      const thumbnailButton = thumbnail.querySelector('button');

      this.elements.thumbnails.querySelectorAll('button').forEach((element) => {(
        element.removeAttribute('aria-current'));
        element.classList.remove('is-active');
      });

      thumbnailButton.setAttribute('aria-current', true);
      thumbnailButton.classList.add('is-active');
      if (this.elements.thumbnails.isSlideVisible(thumbnail, 10)) return;

      this.elements.thumbnails.slider.scrollTo({ left: thumbnail.offsetLeft });
    }

    onArrowButtonClick(event) {
      event.preventDefault();
      this.preventPageShift();
      const scrollDirection = event.currentTarget.name;
      const currentMedia = this.elements.viewer.querySelector('.is-active');
      const previousMedia = currentMedia.previousElementSibling;
      const nextMedia = currentMedia.nextElementSibling;

      if (scrollDirection === 'previous' && previousMedia !== null) {
        this.setActiveMedia(previousMedia.dataset.slideMediaId);
      } else if (scrollDirection === 'next' && nextMedia !== null) {
        this.setActiveMedia(nextMedia.dataset.slideMediaId);
      }
    }

    // Scroll indicator under the gallery. The bar is only rendered on the new
    // product template, so this is a no-op everywhere else.
    initScrollProgress() {
      if (!this.elements.list || !this.elements.progressBar) return;

      this.updateScrollProgress = this.updateScrollProgress.bind(this);

      this.elements.list.addEventListener('scroll', this.onScrollProgress.bind(this), { passive: true });

      const resizeObserver = new ResizeObserver(this.updateScrollProgress);
      resizeObserver.observe(this.elements.list);

      this.updateScrollProgress();
    }

    onScrollProgress() {
      if (this.scrollProgressFrame) return;

      this.scrollProgressFrame = window.requestAnimationFrame(() => {
        this.scrollProgressFrame = null;
        this.updateScrollProgress();
      });
    }

    updateScrollProgress() {
      const list = this.elements.list;
      const bar = this.elements.progressBar;
      if (!list || !bar || list.scrollWidth === 0) return;

      const visibleRatio = Math.min(list.clientWidth / list.scrollWidth, 1);
      const maxScroll = list.scrollWidth - list.clientWidth;
      const progress = maxScroll > 0 ? list.scrollLeft / maxScroll : 0;

      bar.style.width = `${visibleRatio * 100}%`;
      bar.style.left = `${progress * (100 - visibleRatio * 100)}%`;
    }

    // Mouse drag to scroll the main media list. Touch devices keep their native swipe.
    initDragToScroll() {
      const list = this.elements.list;
      if (!list) return;

      this.drag = { pointerId: null, startX: 0, startScrollLeft: 0, moved: false };

      list.addEventListener('pointerdown', this.onDragStart.bind(this));
      list.addEventListener('pointermove', this.onDragMove.bind(this));
      list.addEventListener('pointerup', this.onDragEnd.bind(this));
      list.addEventListener('pointercancel', this.onDragEnd.bind(this));
      list.addEventListener('dragstart', (event) => event.preventDefault());
      // Capture phase so a drag never triggers the zoom link or a video poster
      list.addEventListener('click', this.onDragClick.bind(this), true);
    }

    onDragStart(event) {
      const list = this.elements.list;
      if (event.pointerType !== 'mouse' || event.button !== 0) return;
      if (list.scrollWidth <= list.clientWidth) return;
      // Let loaded media keep their own pointer interactions
      if (event.target.closest('model-viewer, iframe, video')) return;

      this.drag.pointerId = event.pointerId;
      this.drag.startX = event.clientX;
      this.drag.startScrollLeft = list.scrollLeft;
      this.drag.lastX = event.clientX;
      this.drag.lastTime = event.timeStamp;
      this.drag.velocity = 0;
      this.drag.moved = false;
      list.classList.add('is-dragging');
    }

    onDragMove(event) {
      if (this.drag.pointerId === null || event.pointerId !== this.drag.pointerId) return;

      const list = this.elements.list;
      const walk = event.clientX - this.drag.startX;

      if (!this.drag.moved) {
        if (Math.abs(walk) < 5) return;
        this.drag.moved = true;
        if (list.setPointerCapture) list.setPointerCapture(this.drag.pointerId);
      }

      event.preventDefault();
      list.scrollLeft = this.drag.startScrollLeft - walk;

      // Weighted towards the most recent movement, so a flick at the end of a
      // slow drag still reads as a flick
      const elapsed = event.timeStamp - this.drag.lastTime;
      if (elapsed > 0) {
        const velocity = (event.clientX - this.drag.lastX) / elapsed;
        this.drag.velocity = (this.drag.velocity * 0.3) + (velocity * 0.7);
        this.drag.lastX = event.clientX;
        this.drag.lastTime = event.timeStamp;
      }
    }

    onDragEnd(event) {
      if (this.drag.pointerId === null || event.pointerId !== this.drag.pointerId) return;

      const list = this.elements.list;
      if (list.hasPointerCapture && list.hasPointerCapture(this.drag.pointerId)) {
        list.releasePointerCapture(this.drag.pointerId);
      }

      this.drag.pointerId = null;
      list.classList.remove('is-dragging');

      // this.drag.moved stays set so onDragClick can swallow the click that follows
      if (!this.drag.moved) return;

      // Keep CSS snapping off until the settle animation has finished, so it
      // can't jump the list before we get there
      list.classList.add('is-settling');
      // A pause before releasing means it wasn't a flick, whatever came before
      if (event.timeStamp - this.drag.lastTime > 100) this.drag.velocity = 0;
      this.snapAfterDrag(event.clientX - this.drag.startX);

      window.setTimeout(() => {
        if (this.drag.pointerId === null) list.classList.remove('is-settling');
      }, 400);
    }

    onDragClick(event) {
      if (!this.drag || !this.drag.moved) return;
      this.drag.moved = false;
      event.preventDefault();
      event.stopPropagation();
    }

    // Flick velocity, in pixels per millisecond, that moves a slide on its own
    static get FLICK_VELOCITY() { return 0.35; }

    // Portion of a slide a slow drag has to cover to move on
    static get DRAG_RATIO() { return 0.3; }

    snapAfterDrag(walk) {
      const list = this.elements.list;
      const slides = Array.from(list.querySelectorAll('[data-slide-media-id]'));
      if (!slides.length) return;

      const startIndex = this.closestSlideIndex(slides, this.drag.startScrollLeft);
      const slideWidth = slides[0].clientWidth || list.clientWidth;
      let targetIndex = this.closestSlideIndex(slides, list.scrollLeft);

      // Moving left (negative walk / velocity) goes forward through the gallery
      const isFlick = Math.abs(this.drag.velocity) > MediaGallery.FLICK_VELOCITY;
      const isPastThreshold = Math.abs(walk) > slideWidth * MediaGallery.DRAG_RATIO;
      const direction = isFlick ? (this.drag.velocity < 0 ? 1 : -1) : (walk < 0 ? 1 : -1);

      if (isFlick || isPastThreshold) {
        // Never pull back a longer drag that already landed further along
        const nextIndex = startIndex + direction;
        targetIndex = direction > 0 ? Math.max(targetIndex, nextIndex) : Math.min(targetIndex, nextIndex);
      }

      targetIndex = Math.min(Math.max(targetIndex, 0), slides.length - 1);

      const targetSlide = slides[targetIndex];
      list.scrollTo({ left: targetSlide.offsetLeft });
      this.setActiveMediaFromDrag(targetSlide);
    }

    closestSlideIndex(slides, scrollPosition) {
      let closestIndex = 0;

      slides.forEach((slide, index) => {
        if (Math.abs(slide.offsetLeft - scrollPosition) < Math.abs(slides[closestIndex].offsetLeft - scrollPosition)) {
          closestIndex = index;
        }
      });

      return closestIndex;
    }

    // Same state update as setActiveMedia, without the scrolling it does
    setActiveMediaFromDrag(activeMedia) {
      if (!activeMedia || activeMedia.classList.contains('is-active')) return;

      window.pauseAllMedia();

      this.elements.viewer.querySelectorAll('[data-slide-media-id]').forEach((element) => {
        const imageContainer = element.querySelector('.js-media-gallery-image-container');
        element.classList.remove('is-active');
        if (imageContainer) {
          imageContainer.classList.remove('loaded');
        }
      });

      const activeMediaImageContainer = activeMedia.querySelector('.js-media-gallery-image-container');
      activeMedia.classList.add('is-active');
      if (activeMediaImageContainer) {
        activeMediaImageContainer.classList.add('loaded');
      }

      this.playActiveMedia(activeMedia);

      if (this.elements.thumbnails) {
        const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${ activeMedia.dataset.slideMediaId }"]`);
        this.setActiveThumbnail(activeThumbnail);
      }

      this.setArrowButtons(activeMedia);
    }

    playActiveMedia(activeItem) {
      window.pauseAllMedia();
      const deferredMedia = activeItem.querySelector('.js-deferred-media-autoplay');
      if (deferredMedia) deferredMedia.loadContent(false);
    }

    preventStickyHeader() {
      this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
      if (!this.stickyHeader) return;
      this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
    }

    preventPageShift() {
      // To get the scroll position of current webpage
      const TopScroll = window.scrollY || document.documentElement.scrollTop;
      const LeftScroll = window.scrollX || document.documentElement.scrollLeft;

      // if scroll happens, set it to the previous value
      window.onscroll = function() {
        window.scrollTo(LeftScroll, TopScroll)
      };

      // renable scroll after 0.5 second
      setTimeout(() => {
        window.onscroll = function() {};
      }, 500);
    }
  });
}
